import type { QueryClient, QueryKey } from "@tanstack/react-query";

// These endpoints read X-Language and return language-specific server content.
// Account, billing, user-authored, and chart-fact queries intentionally stay
// cached because changing the interface language does not change those values.
const LOCALIZED_API_PREFIXES = [
  "/api/horoscope/",
  "/api/wellness/",
  "/api/jyotish/festivals",
  "/api/jyotish/panchang",
  "/api/jyotish/guidance/me",
  "/api/jyotish/remedies/me",
  "/api/jyotish/reference/gemstones",
  "/api/tarot/card-of-day",
  "/api/content",
  "/api/cosmic-nutrition/profile",
] as const;

export function isLocalizedQueryKey(queryKey: QueryKey): boolean {
  const first = queryKey[0];
  return typeof first === "string" &&
    LOCALIZED_API_PREFIXES.some((prefix) => first.startsWith(prefix));
}

export async function refreshLocalizedQueries(queryClient: QueryClient): Promise<void> {
  // resetQueries cancels the old request and drops its previous-language data
  // before refetching active screens with the newly selected X-Language.
  await queryClient.resetQueries({
    predicate: (query) => isLocalizedQueryKey(query.queryKey),
  });
}
